import {
    URLAPI,
    VEHICLE_PATH,
    VEHICLE_ITEM_PATH,
    VEHICLE_CREATE_PATH,
    VEHICLE_UPDATE_PATH,
    VEHICLES_ITEM_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_vehicle: {
        data: [],

        status: 0,
        message: {},
    },
    _create_vehicle: {
        data: {},
        status: 0,
        message: {},
    },
    _update_vehicle: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_VEHICLE = "GET_ALL_VEHICLE";
export const CREATE_VEHICLE = "CREATE_VEHICLE";
export const UPDATE_VEHICLE = "UPDATE_VEHICLE";

export const vehicle_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_VEHICLE:
            return {
                ...state,
                _get_all_vehicle: action.payload,
            };
        case CREATE_VEHICLE:
            return {
                ...state,
                _create_vehicle: action.payload,
            };
        case UPDATE_VEHICLE:
            return {
                ...state,
                _update_vehicle: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllVehicle = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${VEHICLE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_VEHICLE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_VEHICLE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_VEHICLE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemVehicle = async (token, id) => {
    return await axios.get(`${URLAPI}${VEHICLE_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

export const getItemVehiclesMaintenances = async (token, id) => {
    return await axios.get(`${URLAPI}${VEHICLES_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

//create vehicle
export const createVehicle = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${VEHICLE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_VEHICLE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_VEHICLE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_VEHICLE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateVehicle = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${VEHICLE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_VEHICLE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_VEHICLE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_VEHICLE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_vehicle = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
